import React, { Component } from 'react';
import '../styles/PickedBook.css';

class PickedBook extends Component {
  render () {
    let url = this.props.book.volumeInfo.imageLinks.thumbnail;
    return (
      <div title='Click to remove' className='PickedBook' onClick={() => this.props.removePickedBook(this.props.book)}>
        <img className='PickedBookImage' alt='cover preview' src={url}/>
      </div>
    )
  }
}

export default PickedBook;


// WEBPACK FOOTER //
// ./src/components/PickedBook.js